<div class="assessment-tools-page">
  <HomeNavBar />

  <input
    ref="warehouse_file"
    type="file"
    class="d-none"
    accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.png,.jpg,.jpeg,.gif,.bmp"
    @change="handle_file_upload"
  />

  <div class="assessment-shell">
    <div
      v-if="is_sidebar_open"
      class="assessment-sidebar-backdrop d-lg-none"
      @click="close_sidebar"
    ></div>

    <aside class="assessment-sidebar" :class="{ 'is-open': is_sidebar_open }">
      <div class="px-2 pb-3 border-bottom">
        <p class="text-primary fw-bold">Assessment Tools</p>
        <span class="text-muted text-xs">Indexes &amp; Documents</span>
      </div>

      <nav class="assessment-sidebar-nav">
        <button
          class="assessment-nav-item text-xs fw-bold d-flex align-items-center w-100 rounded-3 text-start"
          :class="{ active: active_tab === 'overview' }"
          type="button"
          :aria-current="active_tab === 'overview' ? 'page' : null"
          @click="show_overview_coming_soon"
        >
          <i class="bi bi-grid-1x2"></i>
          <span>Overview</span>
        </button>

        <button
          class="assessment-nav-item text-xs fw-bold d-flex align-items-center w-100 rounded-3 text-start"
          :class="{ active: active_tab === 'indexes' }"
          type="button"
          :aria-current="active_tab === 'indexes' ? 'page' : null"
          @click="show_indexes_tab"
        >
          <i class="bi bi-folder"></i>
          <span>Assessment Tool Indexes</span>
        </button>
      </nav>

      <div class="tools-sidebar-section">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <p class="text-muted fw-bold mb-0">Index Years</p>
          <button
            v-if="token_exists && user_details.user_role == 'admin'"
            class="btn btn-sm btn-success d-inline-flex align-items-center justify-content-center rounded-circle"
            type="button"
            aria-label="Add index year"
            @click="open_create_year_modal"
          >
            <i class="bi bi-plus-lg"></i>
          </button>
        </div>

        <button
          v-for="folder in year_folders"
          :key="folder.id"
          class="index-item d-flex align-items-center justify-content-between w-100 rounded-3 px-3 py-2 text-start"
          :class="{ active: selected_year_id === folder.id }"
          type="button"
          :aria-current="selected_year_id === folder.id ? 'page' : null"
          @click="open_year_folder(folder)"
        >
          <span>{{ folder.folder_name }}</span>
          <small class="text-muted" v-if="is_latest_folder(folder)">Latest</small>
        </button>

        <button
          v-for="folder in archive_folders"
          :key="folder.id"
          class="index-item d-flex align-items-center justify-content-between w-100 rounded-3 px-3 py-2 text-start text-muted"
          :class="{ active: selected_year_id === folder.id }"
          type="button"
          :aria-current="selected_year_id === folder.id ? 'page' : null"
          @click="open_year_folder(folder)"
        >
          <span>{{ folder.folder_name }}</span>
          <small v-if="is_latest_folder(folder)">Latest</small>
        </button>
      </div>
    </aside>

    <main class="assessment-content">
      <section class="d-flex align-items-start justify-content-between gap-3 flex-xl-row flex-column mb-4">
        <div>
          <button
            class="btn btn-sm btn-outline-secondary d-lg-none mb-3"
            type="button"
            @click="toggle_sidebar"
          >
            <i class="bi bi-list me-1"></i>
            <span>{{ is_sidebar_open ? "Close folders" : "Open folders" }}</span>
          </button>
          <h4 class="fw-bold">
            {{
              active_tab === "overview"
                ? "Overview"
                : folder_stack.length
                  ? folder_stack[folder_stack.length - 1].folder_name
                  : "Assessment Tool Indexes"
            }}
          </h4>
          <p class="text-xs">
            {{
              active_tab === "overview"
                ? "This section is planned and will be implemented later."
                : folder_stack.length
                  ? "Browse the folders and documents available in this section."
                  : "SEEWI index documents organized by year"
            }}
          </p>
        </div>

        <div class="d-flex align-items-center gap-3 flex-wrap justify-content-end w-100 rounded">
          <div class="assessment-search rounded d-flex align-items-center">
            <i class="bi bi-search"></i>
            <input
              ref="searchInput"
              v-model.trim="search_query"
              type="text"
              placeholder="Search folders or files"
            />
          </div>
          <button
            v-if="token_exists && user_details.user_role == 'admin'"
            class="assessment-action-btn assessment-upload d-inline-flex align-items-center"
            type="button"
            @click="handle_add_document"
          >
            <i class="bi bi-upload"></i>
            <span>Upload document</span>
          </button>

        </div>
      </section>

      <section v-if="active_tab === 'indexes'" class="assessment-banner d-flex align-items-center justify-content-between gap-3 rounded p-4 mb-4">
        <div class="flex-grow-1">
          <p class="fw-bold mb-1">
            {{ token_exists && user_details.user_role == 'admin' ? 'Admin access enabled' : 'Assessment tool indexes' }}
          </p>
          <p class="mb-0">
            {{
              token_exists && user_details.user_role == 'admin'
                ? 'Browse, upload, and manage SEEWI index documents.'
                : 'Browse SEEWI index folders and open the available documents.'
            }}
          </p>
        </div>

        <button
          v-if="token_exists && user_details.user_role == 'admin'"
          class="btn btn-sm btn-primary rounded"
          type="button"
          @click="handle_manage"
        >
          <i class="bi me-1" :class="manage_mode ? 'bi-check2' : 'bi-gear'"></i>
          <span>{{ manage_mode ? "Done" : "Manage" }}</span>
        </button>
      </section>

      <section v-if="active_tab === 'indexes'" class="row g-3 mb-4">
        <article class="col-12 col-md-6 col-xl-3">
          <div class="assessment-stat-card d-block p-4 text-center">
          <strong>{{ total_document_count }}</strong>
          <span class="text-xxs text-muted">Documents</span>
          </div>
        </article>

        <article class="col-12 col-md-6 col-xl-3">
          <div class="assessment-stat-card d-block p-4 text-center">
          <strong>{{ total_folder_count }}</strong>
          <span class="text-xxs text-muted">Folders</span>
          </div>
        </article>

        <article class="col-12 col-md-6 col-xl-3">
          <div class="assessment-stat-card d-block p-4 text-center">
          <strong>{{ latest_year_label }}</strong>
          <span class="text-xxs text-muted">Latest SEEWI</span>
          </div>
        </article>

        <article class="col-12 col-md-6 col-xl-3">
          <div class="assessment-stat-card d-block p-4 text-center">
          <strong>{{ dimension_count }}</strong>
          <span class="text-xxs text-muted">Dimensions</span>
          </div>
        </article>
      </section>

      <section v-if="active_tab === 'overview'" class="assessment-section">
        <div class="assessment-empty">
          <i class="bi bi-hourglass-split fs-1"></i>
          <h5 class=" fw-bold text-black">Overview coming soon</h5>
          <p>This is reserved for the dashboard view.</p>
        </div>
      </section>

      <section v-if="active_tab === 'indexes'" class="assessment-section">
        <div class="mb-3">
          <div class="d-none">
            <p class="text-muted fw-bold mb-1">
              {{ folder_stack.length ? "Current Folder" : "Index Years" }}
            </p>
            <div v-if="folder_stack.length" class="d-flex align-items-center flex-wrap gap-2">
              <button class="btn btn-link btn-sm text-decoration-none p-0" type="button" @click="go_root">Assessment Tool Indexes</button>
              <template v-for="(folder, index) in folder_stack" :key="folder.id || index">
                <span class="small text-muted">/</span>
                <button
                  v-if="index !== folder_stack.length - 1"
                  class="btn btn-link btn-sm text-decoration-none p-0"
                  type="button"
                  @click="go_to_folder(index)"
                >
                  {{ folder.folder_name }}
                </button>
                <span v-else class="small text-muted">{{ folder.folder_name }}</span>
              </template>
            </div>
          </div>
        </div>

        <div v-if="loading" class="assessment-empty">
          <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p>Loading assessment tool indexes...</p>
        </div>

        <section
          v-if="active_tab === 'indexes' && folder_stack.length && token_exists && user_details.user_role == 'admin'"
          class="assessment-upload-panel rounded-4 p-1 mb-4 mt-2"
        >
          <div class="drop-zone-stable rounded d-flex align-items-center justify-content-center pointer border-2 rounded-4 p-3 text-center position-relative"
            :class="is_dragging ? 'is-dragging' : ''"
            @dragover.prevent="is_dragging = true"
            @dragenter.prevent="is_dragging = true"
            @dragleave.prevent="is_dragging = false"
            @drop.prevent="handle_drop"
            @click="trigger_file_upload"
          >
            <div v-if="is_uploading" class="assessment-dropzone__loader">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Uploading...</span>
              </div>
              <strong>Uploading document...</strong>
              <span>Please wait while your file is added to this index year.</span>
            </div>

            <div v-else class="d-grid text-center gap-2">
              <i class="bi bi-cloud-arrow-up-fill text-primary fs-4"></i>
              <strong>Drag and drop a document here or click to upload</strong>
              <span>
                Files are uploaded into
                {{
                  active_tab === "overview"
                    ? "Overview"
                    : folder_stack.length
                      ? folder_stack[folder_stack.length - 1].folder_name
                      : "Assessment Tool Indexes"
                }}
              </span>
            </div>
          </div>
        </section>

        <div v-else-if="display_folders.length" class="row g-3">
          <div
            v-for="folder in display_folders"
            :key="folder.id"
            class="col-12 col-lg-6"
          >
            <article
              class="folder-card d-flex align-items-start gap-3 p-3 h-100"
              :class="{ 'is-featured': is_latest_folder(folder) }"
              @click="open_folder(folder)"
            >
              <div class="folder-card-icon">
                <i class="bi" :class="folder_stack.length ? 'bi-folder2-open' : 'bi-folder'"></i>
              </div>

              <div class="folder-card-body flex-grow-1 min-w-0">
                <div class="d-flex align-items-start justify-content-between gap-2 w-100">
                  <h3 class="mb-0 flex-grow-1">{{ folder.folder_name }}</h3>
                  <div class="d-flex align-items-center gap-2 flex-shrink-0 ms-auto">
                    <span class="assessment-chip" :class="{ 'assessment-chip-muted': !is_latest_folder(folder) }">
                      {{ folder_badge(folder) }}
                    </span>

                    <div v-if="manage_mode && token_exists && user_details.user_role == 'admin'" class="dropdown" @click.stop>
                      <button
                        class="assessment-kebab-btn"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        aria-label="Folder actions"
                      >
                        <i class="bi bi-three-dots-vertical"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end shadow-sm">
                        <li>
                          <button class="dropdown-item text-xs" type="button" @click="open_edit_item_modal('folder', folder)">
                            <i class="bi bi-pencil me-2"></i>Edit
                          </button>
                        </li>
                        <li>
                          <button class="dropdown-item text-xs text-danger" type="button" @click="delete_folder(folder)">
                            <i class="bi bi-trash me-2"></i>Delete
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <p>{{ folder_summary(folder) }}</p>
              </div>
            </article>
          </div>
        </div>

        <div v-else-if="!display_files.length" class="assessment-empty">
          <i class="bi bi-folder2-open fs-2"></i>
          <h5>No files found</h5>
          <p>{{ search_query ? "Try a different search term." : "No files are available in this index yet." }}</p>
        </div>

        <div v-if="display_files.length" class="p-2">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <p class="text-muted fw-bold mb-0">Files</p>
          </div>

          <div class="row g-3">
            <div v-for="file in display_files" :key="file.id || get_file_name(file)" class="col-12 col-md-6 col-xl-4">
              <article
                class="assessment-file-card d-flex align-items-center gap-3 p-3 h-100"
                :class="{ pointer: get_file_url(file) }"
                @click="open_file(file)"
              >
                <div class="file-card-icon">
                  <i class="bi bi-file-earmark-text"></i>
                </div>

                <div class="file-card-body">
                  <strong>{{ get_file_name(file) }}</strong>
                  <span>{{ file.file?.date || file.date_created || 'Click to preview' }}</span>
                </div>

                <div v-if="manage_mode && token_exists && user_details.user_role == 'admin'" class="dropdown ms-auto" @click.stop>
                  <button
                    class="assessment-kebab-btn"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-label="File actions"
                  >
                    <i class="bi bi-three-dots-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end shadow-sm">
                    <li>
                      <button class="dropdown-item text-xs" type="button" @click="open_edit_item_modal('file', file)">
                        <i class="bi bi-pencil me-2"></i>Edit
                      </button>
                    </li>
                    <li>
                      <button class="dropdown-item text-xs text-danger" type="button" @click="delete_file(file)">
                        <i class="bi bi-trash me-2"></i>Delete
                      </button>
                    </li>
                  </ul>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>

    </main>
  </div>

  <div class="modal fade" id="assessmentYearModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-sm">
        <div class="modal-header">
          <h5 class="modal-title">Create Index Year</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <label class="form-label text-dark fw-semibold">Index year folder name</label>
          <input
            v-model.trim="folder_name"
            type="text"
            class="form-control"
            placeholder="Example: SEEWI 2025"
          />
          <small class="text-muted text-xs">This creates a new top-level index year folder in the indexes list.</small>
          <p v-if="validation_error" class="text-danger">{{ validation_error }}</p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary rounded" @click="create_folder">
            Create
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="assessmentUploadTargetModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-sm">
        <div class="modal-header">
          <h5 class="modal-title">Choose Index Year</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <label class="form-label text-dark fw-semibold">Upload this document into</label>
          <select v-model="selected_upload_folder_id" class="form-select">
            <option disabled value="">Select an index year</option>
            <option v-for="folder in folders" :key="folder.id" :value="folder.id">
              {{ folder.folder_name }}
            </option>
          </select>
          <small class="text-muted text-xs">You can upload from the main page and assign the file to any index year.</small>
          <p v-if="upload_target_error" class="text-danger">{{ upload_target_error }}</p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary rounded" @click="confirm_root_upload">
            Continue upload
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="assessmentEditItemModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-sm">
        <div class="modal-header">
          <h5 class="modal-title">
            Edit {{ editing_item_type === "folder" ? "Folder" : "File" }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <label class="form-label text-dark fw-semibold">
            {{ editing_item_type === "folder" ? "Folder name" : "File name" }}
          </label>
          <input
            v-model.trim="editing_item_name"
            type="text"
            class="form-control"
            placeholder="Enter name"
            @keyup.enter="save_item_edit"
          />
          <p v-if="edit_validation_error" class="text-danger text-xs mt-2 mb-0">{{ edit_validation_error }}</p>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-light rounded" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-sm btn-primary rounded" @click="save_item_edit">
            Save changes
          </button>
        </div>
      </div>
    </div>
  </div>

  <teleport to="body">
    <div class="modal fade" id="assessment_preview_modal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content border-0 shadow">
          <div class="modal-header">
            <h5 class="modal-title">Preview</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close_preview"></button>
          </div>

          <div class="modal-body text-center position-relative">
            <div v-if="loading_preview" class="d-flex justify-content-center align-items-center assessment-preview-loader">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <div v-if="preview_type === 'pdf'" class="ratio ratio-16x9">
              <iframe :key="preview_key" :src="preview_url" width="100%" height="100%" frameborder="0" @load="on_content_loaded"></iframe>
            </div>

            <div v-else-if="preview_type === 'image'">
              <img :key="preview_key" :src="preview_url" class="img-fluid rounded" @load="on_content_loaded" />
            </div>

            <div v-else-if="preview_type === 'video'">
              <video :key="preview_key" controls class="img-fluid rounded" @loadedmetadata="on_content_loaded">
                <source :src="preview_url" :type="'video/' + preview_url.split('.').pop()" />
              </video>
            </div>

            <div v-else-if="preview_type === 'audio'">
              <audio :key="preview_key" controls class="w-100 my-3" @loadedmetadata="on_content_loaded">
                <source :src="preview_url" :type="'audio/' + preview_url.split('.').pop()" />
              </audio>
            </div>

            <div v-else-if="preview_type === 'office'" class="ratio ratio-16x9">
              <iframe
                :key="preview_key"
                :src="'https://view.officeapps.live.com/op/embed.aspx?src=' + encodeURIComponent(preview_url)"
                width="100%"
                height="100%"
                frameborder="0"
                @load="on_content_loaded"
              ></iframe>
            </div>

            <div v-else-if="preview_type === 'text'">
              <iframe :key="preview_key" :src="preview_url" width="100%" height="500px" frameborder="0" @load="on_content_loaded"></iframe>
            </div>

            <div v-else>
              <p class="text-muted mb-2">Preview not available for this file type.</p>
              <a :href="preview_url" target="_blank" class="btn btn-sm btn-primary rounded">
                Open file
              </a>
            </div>

            <a
              v-if="preview_url"
              :href="preview_url"
              target="_blank"
              download
              class="assessment-preview-download btn btn-sm btn-primary rounded d-inline-flex align-items-center gap-1"
            >
              <i class="bi bi-download"></i>
              <span>Download</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</div>
